import { DataGlueGraph } from '@glueapp/graph-types';
import { Node } from '@glueapp/graph-types';
import { IntegrationAccess } from '@glueapp/graph-types';
import { dictionaryFromStringTuple } from '@glueapp/graph-types';

export function areAllIntegrationsAndNodesForGraphPresent(
    graph: DataGlueGraph,
    nodeLibrary: Node[],
    integrationAccesses: IntegrationAccess[],
): boolean {
    const nodeLibraryIDDictionary: { [key: string]: Node } = dictionaryFromStringTuple(nodeLibrary, node => [node.id, node]);
    const integrationAccessProviders: Set<string> = new Set(integrationAccesses.map(ia => ia.provider));

    return graph.nodeInstances.every(nodeInstance => {
        const node = nodeLibraryIDDictionary[nodeInstance.nodeId];
        if (node === undefined) {
            return false;
        }
        if (node.integration === undefined) {
            return true;
        }
        return integrationAccessProviders.has(node.integration.provider) && nodeInstance.selectedIntegrationAccess !== undefined;
    });
}
